// ============================================================
// Wauvea WebXR — Configuration
// Dome dimensions, zone layout, and defaults
// ============================================================

export const CONFIG = {
  dome: {
    radius: 50,
    skyboxPath: '/assets/skybox.jpg',
    ambientColor: 0x0a0a1a,
  },

  mainScreen: {
    arcDegrees: 190,
    height: 18,
    radius: 30,
    yPosition: 6,
    segments: 64,
  },

  // ── Zone layout (matches sketch: 2×2 grid per side + full-width overhead) ──
  zones: [
    // Left side — 2 columns × 2 rows
    // Top row (outer → inner)
    { id: 'graphic-left',      type: 'graphic', label: 'Graphic Zone', angle: -108, yPosition: 11, width: 5, height: 6 },
    { id: 'merch-left-top',    type: 'merch',   label: 'Merch Zone',   angle: -99,  yPosition: 11, width: 5, height: 6 },
    // Bottom row (outer → inner)
    { id: 'merch-left-bottom', type: 'merch',   label: 'Merch Zone',   angle: -108, yPosition: 3,  width: 5, height: 6 },
    { id: 'ad-left',           type: 'ad',      label: 'Ad Zone',      angle: -99,  yPosition: 3,  width: 5, height: 6 },

    // Right side — 2 columns × 2 rows (mirror)
    // Top row (inner → outer)
    { id: 'merch-right-top',   type: 'merch',   label: 'Merch Zone',   angle: 99,   yPosition: 11, width: 5, height: 6 },
    { id: 'graphic-right',     type: 'graphic', label: 'Graphic Zone', angle: 108,  yPosition: 11, width: 5, height: 6 },
    // Bottom row (inner → outer)
    { id: 'ad-right',          type: 'ad',      label: 'Ad Zone',      angle: 99,   yPosition: 3,  width: 5, height: 6 },
    { id: 'merch-right-bottom',type: 'merch',   label: 'Merch Zone',   angle: 108,  yPosition: 3,  width: 5, height: 6 },

    // Overhead — full-width ceiling screen (sky extension)
    { id: 'overhead', type: 'graphic', label: 'Overhead Screen', overhead: true, width: 55, height: 30 },
  ],

  sideScreens: {
    radius: 30,       // Same radius as main screen — panels sit on the dome wall
    height: 6,        // Default height for side zone panels
    yPosition: 6,     // Fallback Y center
  },

  camera: {
    fov: 75,
    near: 0.1,
    far: 200,
  },

  // Zone type color coding
  zoneColors: {
    graphic: 0x6C5CE7,
    merch: 0xFF6B9D,
    ad: 0x00D2FF,
    side: 0xFECA57,
  },
};
